import Header from "../../components/header/Header";
import {
  HStack,
  Hidden,
  VStack,
  Text,
  Box,
  Pressable,
  Divider,
  ScrollView,
  Tooltip,
  Badge,
} from "native-base";
import _ from "lodash";
import React, { FC, useState, useEffect } from "react";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import Placeholder from "../../components/Ads/Placeholder";
import Right from "../../components/body/Right";
import { Dimensions } from "react-native";
import disconnect from "../../assets/images/disconnected.png";
import { Loc } from "../../App/Loc";
import AVCreateTeam from "./AVCreateTeam";
import ProfileHeader from "./ProfileHeader";
import { RootStateOrAny, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PreviewAlbums from "../../components/common/PreviewAlbums";
import useAlerts from "../../Hooks/useAlerts";
import {
  HuddleAvatarIcon,
  GeneralAccountIcon,
  LoginAccountIcon,
  TranslationIcon,
  MyPaymentsIcon,
  MyCollectionsIcon,
  MyTransactionsIcon,
  MyPlanIcon,
} from "../../assets/icons/icon-assets";

interface Props {
  children?: any | undefined;
  isGeneral?: any | undefined;
  setIsGeneral?: any | undefined;
  isLoginAccount?: any | undefined;
  setIsLoginAccount?: any | undefined;
  isAutoTrans?: any | undefined;
  setIsAutoTrans?: any | undefined;
  isMyPayments?: any | undefined;
  setIsMyPayments?: any | undefined;
  isMyCollections?: any | undefined;
  setIsMyCollections?: any | undefined;
  isMyTransactions?: any | undefined;
  setIsMyTransactions?: any | undefined;
  isMyPlan?: any | undefined;
  setIsMyPlan?: any | undefined;
  isRole?: any | undefined;
  setIsRole?: any | undefined;
  Entity?: any | undefined;
  setIsEntity?: any | undefined;
  leagueGameEntity?: any | undefined;
  type?: any | undefined;
  isHomepage?: any | undefined;
  setShowCreateNewPage: any | undefined;
  showCreateNewPage: any | undefined;
  setCreateType: any | undefined;
  createType: any | undefined;
  setPassEntity: any | undefined;
  passEntity: any | undefined;
  setIsShowEdit: any | undefined;
  isOpenConvo: any | undefined;
  setIsOpenConvo: any | undefined;
  isConvoData: any | undefined;
  setIsConvoData: any | undefined;
  setIshuddleData: any | undefined;
  //unReadConvo?: any | undefined;
  fromMemberTabHuddle?: boolean;
}

const AVBody: FC<Props> = ({
  children,
  isGeneral,
  setIsGeneral,
  isLoginAccount,
  setIsLoginAccount,
  isAutoTrans,
  setIsAutoTrans,
  isMyPayments,
  setIsMyPayments,
  isMyCollections,
  setIsMyCollections,
  isMyTransactions,
  setIsMyTransactions,
  isMyPlan,
  setIsMyPlan,
  isRole,
  setIsRole,
  Entity,
  type,
  isHomepage,
  setShowCreateNewPage,
  showCreateNewPage,
  setCreateType,
  createType,
  setPassEntity,
  passEntity,
  leagueGameEntity,
  setIsShowEdit,
  isOpenConvo,
  setIsOpenConvo,
  isConvoData,
  setIsConvoData,
  setIshuddleData,
  //unReadConvo,
  fromMemberTabHuddle,
}) => {
  const dimension = Dimensions.get("window");
  const dimensions = useWindowDimension();
  const isMobile = dimension?.width <= 500 || false;
  const [isEditEntireSeries, setIsEditEntireSeries] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState<any>([]);
  const [profile, setProfile] = useState<any>({
    background: null,
    pic: null,
    thumb: null,
    gallery: null,
    previousPic: null,
    text: null,
    color: null,
  });
  const [isGroupChat, setIsGroupChat] = useState(false);
  const currentUser: any = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const userconvo = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );
  const isOnline = useSelector(
    (state: RootStateOrAny) => state.user.isOnline
  );

  const { id } = useParams();
  const [isChannelData, setIsChannelData] = useState(() => {
    // First, get all channels from orgs
    const channels =
      currentUser?.orgs?.filter((org) => org.type === "Channel") ?? [];

    // Create a map of conversation lastUpdated times for quick lookup
    const convoUpdateMap = new Map(
      userconvo?.map((convo) => [convo?.id, convo?.lastUpdated]) ?? [],
    );

    // Sort channels based on their corresponding conversation's lastUpdated
    const sortedChannels = channels.sort((a, b) => {
      const lastUpdatedA: any =
        convoUpdateMap.get(a.data) || new Date().toISOString();
      const lastUpdatedB: any =
        convoUpdateMap.get(b.data) || new Date().toISOString();

      // Convert to Date objects for comparison
      const dateA = new Date(lastUpdatedA);
      const dateB = new Date(lastUpdatedB);

      // Sort in descending order (most recent first)
      return dateB.getTime() - dateA.getTime();
    });

    // If coming from Huddle Member Tab, just keep the channel with matching ID
    if (fromMemberTabHuddle) {
      return sortedChannels?.filter((x) => x?.id === id);
    }

    return sortedChannels;
  });

  const [showAllChannels, setShowAllChannels] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState<string | null>(
    id || isChannelData?.[0]?.id || null,
  );
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setSelectedChannel(id);
      const channel = isChannelData.find((ch) => ch.id === id);
      if (channel) {
        setIshuddleData(channel);
      }
    }
  }, [id, isChannelData]);

  useEffect(() => {
    if (!selectedChannel && isChannelData?.[0]) {
      setSelectedChannel(isChannelData[0].id);
      handleHuddleNavigate(isChannelData[0]);
    }
  }, [isChannelData]);

  const handleHuddleNavigate = (channel) => {
    if (setIshuddleData !== undefined) {
      setIshuddleData(channel);
      navigate(`/huddles/${channel.id}`, {
        state: { type: Loc.currentLang.activity.headers.chat },
      });
    }
  };

  const openPreview = (item, allImages) => {
    setShowPreview(true);
    setSingleImage(item);
    setShowAllImage([item]);
  };

  useEffect(() => {
    if (!currentUser?.orgs) return;

    // Get all channels from orgs
    const channels =
      currentUser.orgs.filter((org) => org.type === "Channel") ?? [];

    // Create a map of conversation lastUpdated times for quick lookup
    const convoUpdateMap = new Map(
      userconvo?.map((convo) => [convo?.id, convo?.lastUpdated]) ?? [],
    );

    // Sort channels based on their corresponding conversation's lastUpdated
    const sortedChannels = channels.sort((a, b) => {
      const lastUpdatedA: any =
        convoUpdateMap.get(a.data) || new Date().toISOString();
      const lastUpdatedB: any =
        convoUpdateMap.get(b.data) || new Date().toISOString();

      // Convert to Date objects for comparison
      const dateA = new Date(lastUpdatedA);
      const dateB = new Date(lastUpdatedB);

      // Sort in descending order (most recent first)
      return dateB.getTime() - dateA.getTime();
    });

    if (fromMemberTabHuddle) {
      setIsChannelData(sortedChannels?.filter((x) => x?.id === id));
    } else {
      setIsChannelData(sortedChannels);
    }
  }, [currentUser?.orgs]); // Re-run when currentUser.orgs or userconvo changes

  //useEffect(() => {
  //  console.log("unReadConvo", unReadConvo);
  //}, [unReadConvo]);

  //// Huddles unReadCounts
  //const [unReadConvo, setUnReadConvo] = useState<any[]>([]);
  //const userAlertList = useSelector((state: RootStateOrAny) => {
  //  const alerts = state?.alerts?.alert || [];
  //  return Array.isArray(alerts[0]) ? alerts[0] : alerts; // flatten if wrapped
  //});

  //useEffect(() => {
  //  if (!userAlertList?.length) {
  //    setUnReadConvo([]);
  //    return;
  //  }

  //  const unReadconvoData = userAlertList.filter(
  //    (x: any) =>
  //      x?.actionTaken === undefined &&
  //      x?.data?.feed?.type === "GroupConvo" &&
  //      (x?.alertType === "NewDM" || x?.alertType === "ReplyDM") &&
  //      x?.data?.person?.id !== currentUser?.id
  //  );

  //  setUnReadConvo(unReadconvoData);
  //}, [userAlertList]);

  return (
    <div
      className="container scrollbar"
      style={{ height: "100vh", width: "100%" }}
    >
      <Header
        dimensions={dimensions}
        headerHeight={60}
        isOpenConvo={isOpenConvo}
        setIsOpenConvo={setIsOpenConvo}
        isConvoData={isConvoData}
        setIsConvoData={setIsConvoData}
        isGroupChat={isGroupChat}
        setIsGroupChat={setIsGroupChat}
      />
      <HStack
        mt={{ base: "105px" }}
        mr={[0, 0, "auto", "auto"]}
        ml={[0, 0, "auto", "auto"]}
        maxWidth={"appMaxWidth"}
        width={[dimensions.width, "100%"]}
        paddingLeft={isMobile ? "5px" : "39px"}
        paddingRight={isMobile ? "5px" : "31px"}
      >
        <Hidden only={["base", "sm", "md"]}>
          <VStack
            width={
              type === "huddlesList" && !showCreateNewPage ? "400px" : "227px"
            }
          >
            {type === "accountsettings" ? (
              <VStack width={"227px"} position={"fixed"}>
                <Box
                  bgColor={"AVColor.white"}
                  p={4}
                  borderRadius="lg"
                  shadow="sm"
                >
                  {/* General Section */}
                  <Text
                    fontSize="16px"
                    fontWeight="medium"
                    color="gray.600"
                    mb={2}
                  >
                    {Loc.currentLang.menu.general}
                  </Text>
                  <VStack space={2}>
                    <Pressable
                      backgroundColor={isGeneral ? "#32AE781A" : ""}
                      borderRadius="7px"
                      _hover={{
                        bg: "#32AE781A",
                        borderRadius: "7px",
                      }}
                      onPress={() => {
                        setIsGeneral(true);
                        setIsRole(false);
                        setIsLoginAccount(false);
                        setIsAutoTrans(false);
                        setIsMyPayments(false);
                        setIsMyCollections(false);
                        setIsMyTransactions(false);
                        setIsMyPlan(false);
                      }}
                    >
                      <HStack space={3} p={3} alignItems="center">
                        <Box>
                          <GeneralAccountIcon
                            width="20px"
                            height="20px"
                            color={isGeneral ? "#32AE78" : "#666666"}
                          />
                        </Box>
                        <Text
                          fontSize="16px"
                          color={isGeneral ? "#32AE78" : "rgba(0,0,0,0.85)"}
                          fontWeight={isGeneral ? "500" : "400"}
                        >
                          {Loc.currentLang.menu.account}
                        </Text>
                      </HStack>
                    </Pressable>

                    {isHomepage && (
                      <>
                        <Pressable
                          backgroundColor={isLoginAccount ? "#32AE781A" : ""}
                          borderRadius="7px"
                          _hover={{
                            bg: "#32AE781A",
                            borderRadius: "7px",
                          }}
                          onPress={() => {
                            setIsGeneral(false);
                            setIsRole(false);
                            setIsLoginAccount(true);
                            setIsAutoTrans(false);
                            setIsMyPayments(false);
                            setIsMyCollections(false);
                            setIsMyTransactions(false);
                            setIsMyPlan(false);
                          }}
                        >
                          <HStack space={3} p={3} alignItems="center">
                            <Box>
                              <LoginAccountIcon
                                width="20px"
                                height="20px"
                                color={isLoginAccount ? "#32AE78" : "#666666"}
                              />
                            </Box>
                            <Text
                              fontSize="16px"
                              color={
                                isLoginAccount ? "#32AE78" : "rgba(0,0,0,0.85)"
                              }
                              fontWeight={isLoginAccount ? "500" : "400"}
                            >
                              {Loc.currentLang.menu.loginAccounts}
                            </Text>
                          </HStack>
                        </Pressable>
                      </>
                    )}

                    {!isHomepage &&
                      Entity !== undefined &&
                      Entity?.type !== "Event" &&
                      Entity?.type !== "Person" && (
                        <>
                          <Pressable
                            backgroundColor={isRole ? "#32AE781A" : ""}
                            borderRadius="7px"
                            _hover={{
                              bg: "#32AE781A",
                              borderRadius: "7px",
                            }}
                            onPress={() => {
                              setIsGeneral(false);
                              setIsRole(true);
                              setIsLoginAccount(false);
                              setIsAutoTrans(false);
                              setIsMyPayments(false);
                              setIsMyCollections(false);
                              setIsMyTransactions(false);
                              setIsMyPlan(false);
                            }}
                          >
                            <HStack space={3} p={3} alignItems="center">
                              <Box>
                                <LoginAccountIcon
                                  width="20px"
                                  height="20px"
                                  color={isRole ? "#32AE78" : "#666666"}
                                />
                              </Box>
                              <Text
                                fontSize="16px"
                                color={isRole ? "#32AE78" : "rgba(0,0,0,0.85)"}
                                fontWeight={isRole ? "500" : "400"}
                              >
                                {Loc.currentLang.menu.roles}
                              </Text>
                            </HStack>
                          </Pressable>
                        </>
                      )}
                  </VStack>

                  {/* Funds Section */}
                  <>
                    <Text
                      fontSize="16px"
                      fontWeight="medium"
                      color="gray.600"
                      mt={6}
                      mb={2}
                    >
                      {Loc.currentLang.menu.funds}
                    </Text>
                    {/* My Payment */}
                    <VStack space={2}>
                      <Pressable
                        backgroundColor={isMyPayments ? "#32AE781A" : ""}
                        borderRadius="7px"
                        _hover={{
                          bg: "#32AE781A",
                          borderRadius: "7px",
                        }}
                        onPress={() => {
                          setIsMyPayments(true);
                          setIsGeneral(false);
                          setIsRole(false);
                          setIsLoginAccount(false);
                          setIsAutoTrans(false);
                          setIsMyCollections(false);
                          setIsMyTransactions(false);
                          setIsMyPlan(false);
                        }}
                      >
                        <HStack space={3} p={3} alignItems="center">
                          <Box>
                            <MyPaymentsIcon
                              width="20px"
                              height="20px"
                              color={isMyPayments ? "#32AE78" : "#666666"}
                            />
                          </Box>
                          <Text
                            fontSize="16px"
                            color={
                              isMyPayments ? "#32AE78" : "rgba(0,0,0,0.85)"
                            }
                            fontWeight={isMyPayments ? "500" : "400"}
                          >
                            {Loc.currentLang.menu.myPayments}
                          </Text>
                        </HStack>
                      </Pressable>

                      {/* My Collections - FEATURE IMPLEMENTATION */}
                      {/*<Pressable*/}
                      {/*  backgroundColor={isMyCollections ? "#32AE781A" : ""}*/}
                      {/*  borderRadius="7px"*/}
                      {/*  _hover={{*/}
                      {/*    bg: "#32AE781A",*/}
                      {/*    borderRadius: "7px",*/}
                      {/*  }}*/}
                      {/*  onPress={() => {*/}
                      {/*    setIsMyCollections(true);*/}
                      {/*    setIsGeneral(false);*/}
                      {/*    setIsRole(false);*/}
                      {/*    setIsLoginAccount(false);*/}
                      {/*    setIsAutoTrans(false);*/}
                      {/*    setIsMyPayments(false);*/}
                      {/*    setIsMyTransactions(false);*/}
                      {/*  }}*/}
                      {/*>*/}
                      {/*  <HStack space={3} p={3} alignItems="center">*/}
                      {/*    <Box>*/}
                      {/*      <MyCollectionsIcon*/}
                      {/*        width="20px"*/}
                      {/*        height="20px"*/}
                      {/*        color={isMyCollections ? "#32AE78" : "#000000D9"}*/}
                      {/*      />*/}
                      {/*    </Box>*/}
                      {/*    <Text*/}
                      {/*      fontSize="16px"*/}
                      {/*      color={*/}
                      {/*        isMyCollections ? "#32AE78" : "rgba(0,0,0,0.85)"*/}
                      {/*      }*/}
                      {/*      fontWeight={isMyCollections ? "500" : "400"}*/}
                      {/*    >*/}
                      {/*      {Loc.currentLang.menu.myCollections}*/}
                      {/*    </Text>*/}
                      {/*  </HStack>*/}
                      {/*</Pressable>*/}

                      {/* My Transactions */}
                      <Pressable
                        backgroundColor={isMyTransactions ? "#32AE781A" : ""}
                        borderRadius="7px"
                        _hover={{
                          bg: "#32AE781A",
                          borderRadius: "7px",
                        }}
                        onPress={() => {
                          setIsMyTransactions(true);
                          setIsGeneral(false);
                          setIsRole(false);
                          setIsLoginAccount(false);
                          setIsAutoTrans(false);
                          setIsMyPayments(false);
                          setIsMyCollections(false);
                          setIsMyPlan(false);
                        }}
                      >
                        <HStack space={3} p={3} alignItems="center">
                          <Box>
                            <MyTransactionsIcon
                              width="20px"
                              height="20px"
                              color={isMyTransactions ? "#32AE78" : "#666666"}
                            />
                          </Box>
                          <Text
                            fontSize="16px"
                            color={
                              isMyTransactions ? "#32AE78" : "rgba(0,0,0,0.85)"
                            }
                            fontWeight={isMyTransactions ? "500" : "400"}
                          >
                            {Loc.currentLang.menu.myTransactions}
                          </Text>
                        </HStack>
                      </Pressable>
                    </VStack>
                  </>

                  {/* Plan Section */}
                  {Entity?.type !== "Event" && (
                    <>
                      <Text
                        fontSize="16px"
                        fontWeight="medium"
                        color="gray.600"
                        mt={6}
                        mb={2}
                      >
                        {Loc.currentLang.menu.plan}
                      </Text>
                      {/* My Plan */}
                      <VStack space={2}>
                        <Pressable
                          backgroundColor={isMyPlan ? "#32AE781A" : ""}
                          borderRadius="7px"
                          _hover={{
                            bg: "#32AE781A",
                            borderRadius: "7px",
                          }}
                          onPress={() => {
                            setIsMyPlan(true);
                            setIsGeneral(false);
                            setIsRole(false);
                            setIsLoginAccount(false);
                            setIsAutoTrans(false);
                            setIsMyPayments(false);
                            setIsMyCollections(false);
                            setIsMyTransactions(false);
                          }}
                        >
                          <HStack space={3} p={3} alignItems="center">
                            <Box>
                              <MyPlanIcon
                                width="20px"
                                height="20px"
                                color={isMyPlan ? "#32AE78" : "#666666"}
                              />
                            </Box>
                            <Text
                              fontSize="16px"
                              color={isMyPlan ? "#32AE78" : "rgba(0,0,0,0.85)"}
                              fontWeight={isMyPlan ? "500" : "400"}
                            >
                              {Loc.currentLang.menu.myPlan}
                            </Text>
                          </HStack>
                        </Pressable>
                      </VStack>
                    </>
                  )}

                  {/* Translation Section */}
                  <>
                    <Text
                      fontSize="16px"
                      fontWeight="medium"
                      color="gray.600"
                      mt={6}
                      mb={2}
                    >
                      {Loc.currentLang.menu.translation}
                    </Text>
                    <VStack space={2}>
                      <Pressable
                        backgroundColor={isAutoTrans ? "#32AE781A" : ""}
                        borderRadius="7px"
                        _hover={{
                          bg: "#32AE781A",
                          borderRadius: "7px",
                        }}
                        onPress={() => {
                          setIsAutoTrans(true);
                          setIsGeneral(false);
                          setIsRole(false);
                          setIsLoginAccount(false);
                          setIsMyPayments(false);
                          setIsMyCollections(false);
                          setIsMyTransactions(false);
                          setIsMyPlan(false);
                        }}
                      >
                        <HStack space={3} p={3} alignItems="center">
                          <Box>
                            <TranslationIcon
                              width="20px"
                              height="20px"
                              color={isAutoTrans ? "#32AE78" : "#666666"}
                            />
                          </Box>
                          <Text
                            fontSize="16px"
                            color={isAutoTrans ? "#32AE78" : "rgba(0,0,0,0.85)"}
                            fontWeight={isAutoTrans ? "500" : "400"}
                          >
                            {Loc.currentLang.manageConversation.autoTranslation}
                          </Text>
                        </HStack>
                      </Pressable>
                    </VStack>
                  </>
                </Box>
              </VStack>
            ) : (
              type === "huddlesList" &&
              (() => {
                //const convo = userAlertList?.filter(
                //  (x: any) =>
                //    x?.actionTaken == undefined &&
                //    (x?.alertType == "NewDM" || x?.alertType == "ReplyDM") &&
                //    x?.data?.person?.id !== currentUser?.id,
                //);

                //const unreadconvo = Array.isArray(convo)
                //  ? _.uniqBy(convo, "data.feed.id")
                //  : [];

                return !showCreateNewPage &&
                  currentUser?.orgs?.filter((x) => x?.type === "Channel")
                    .length > 0 ? (
                  <VStack width="400px" position="fixed">
                    <Box
                      width="100%"
                      px="4"
                      py="3"
                      bgColor={"AVColor.white"}
                      borderRadius="10px"
                      shadow={2}
                      borderColor={"AVColor.buttonBg"}
                    >
                      <Text
                        mb="2"
                        lineHeight="24px"
                        fontWeight={"400"}
                        fontSize={"24px"}
                        color={"AVColor.primary"}
                      >
                        {Loc.currentLang.menu.huddless}
                      </Text>

                      <Divider mb="2" opacity="0.2" />

                      <ScrollView
                        maxHeight={
                          showAllChannels
                            ? dimensions.height - 200
                            : dimensions.height - 100
                        }
                        showsVerticalScrollIndicator={true}
                      >
                        <VStack>
                          {(showAllChannels
                            ? isChannelData
                            : isChannelData.slice(0, 8)
                          ).map((channel: any, index: number) => (
                            <Tooltip
                              key={channel.id}
                              label={channel.title}
                              placement="right"
                              openDelay={500}
                              hasArrow
                              closeOnClick={true}
                              isOpen={
                                activeTooltip === channel.id &&
                                selectedChannel !== channel.id
                              }
                              bg="gray.800"
                              _text={{
                                color: "white",
                                fontSize: "sm",
                                px: 2,
                                py: 1,
                              }}
                            >
                              <Pressable
                                onPress={() => {
                                  setSelectedChannel(channel.id);
                                  handleHuddleNavigate(channel);
                                  setActiveTooltip(null);
                                }}
                                onHoverIn={() => setActiveTooltip(channel.id)}
                                onHoverOut={() => setActiveTooltip(null)}
                                _hover={{
                                  bg: "gray.100",
                                  borderRadius: "7px",
                                }}
                                width="100%"
                              >
                                <HStack
                                  space="3"
                                  alignItems="center"
                                  p="2"
                                  bg={
                                    selectedChannel === channel.id
                                      ? "gray.200"
                                      : "transparent"
                                  }
                                  borderRadius="7px"
                                >
                                  <Box
                                    alignItems="center"
                                    justifyContent="center"
                                  >
                                    <HuddleAvatarIcon
                                      height="20px"
                                      width="27px"
                                    />
                                  </Box>
                                  <HStack
                                    alignItems="center"
                                    space={2}
                                    maxWidth="300px"
                                  >
                                    <Text
                                      fontSize="16px"
                                      color="gray.900"
                                      lineHeight="40px"
                                      isTruncated
                                      maxWidth="300px"
                                      numberOfLines={1}
                                      fontWeight={
                                        selectedChannel === channel.id
                                          ? 500
                                          : 400
                                      }
                                    >
                                      {channel.title}
                                    </Text>

                                    {/*{(() => {*/}
                                    {/*  const channelUnread = unReadConvo?.filter(*/}
                                    {/*    (x) =>*/}
                                    {/*      x?.data?.feed?.id === channel.data && // match the channel*/}
                                    {/*      x?.data?.feed?.id !== selectedChannel &&*/}
                                    {/*      x?.data?.postObj?.owner?.type !==*/}
                                    {/*        "Convo" &&*/}
                                    {/*      x?.wardName === undefined,*/}
                                    {/*  );*/}

                                    {/*  return channelUnread?.length > 0 ? (*/}
                                    {/*    <Badge*/}
                                    {/*      colorScheme="info"*/}
                                    {/*      size="sm"*/}
                                    {/*      rounded="full"*/}
                                    {/*      variant="solid"*/}
                                    {/*      alignSelf="center"*/}
                                    {/*      _text={{ fontSize: 9 }}*/}
                                    {/*    >*/}
                                    {/*      {channelUnread.length}*/}
                                    {/*    </Badge>*/}
                                    {/*  ) : null;*/}
                                    {/*})()}*/}
                                  </HStack>
                                </HStack>
                              </Pressable>
                            </Tooltip>
                          ))}

                          {isChannelData.length > 8 && !showAllChannels && (
                            <Pressable onPress={() => setShowAllChannels(true)}>
                              <Text
                                fontSize="14px"
                                color="#00A09B"
                                lineHeight="20px"
                              >
                                {Loc.currentLang.lang.seeAllHuddles}
                              </Text>
                            </Pressable>
                          )}

                          {showAllChannels && (
                            <Pressable
                              onPress={() => setShowAllChannels(false)}
                            >
                              <Text
                                fontSize="14px"
                                color="#00A09B"
                                lineHeight="20px"
                              >
                                {Loc.currentLang.lang.showLess}
                              </Text>
                            </Pressable>
                          )}
                        </VStack>
                      </ScrollView>
                    </Box>
                  </VStack>
                ) : (
                  <Placeholder />
                );
              })()
            )}
          </VStack>
        </Hidden>

        <VStack
          marginBottom={isMobile ? "15%" : ""}
          flex={[1, "30%"]}
          marginLeft={isMobile ? "" : "18px"}
        >
        {!isOnline && (
          <VStack
            padding={"10px"}
            backgroundColor={"white"}
            shadow={5}
            borderRadius={"10px"}
            width={isMobile ? "100%" : "fit-content"}
            zIndex={999}
            left={isMobile ? "" : "40%"}
          >
            <HStack space={20} marginLeft={"10px"}>
              <Box position={"absolute"} top={"10px"}>
                <img
                  src={disconnect}
                  height={"25px"}
                  width={"25px"}
                  alt={""}
                />
              </Box>
              <Text textAlign={"center"} fontWeight={"medium"}>
                {Loc.currentLang.menu.offlineMsg}
              </Text>
            </HStack>
            <HStack space={40} marginLeft={"20px"}>
              <Text
                textAlign={"center"}
                color={"gray.400"}
                marginLeft={"25px"}
              >
                {Loc.currentLang.menu.internetDisconnectedMsg}
              </Text>
            </HStack>
          </VStack>
        )}

          {!showCreateNewPage && children}
          {showCreateNewPage && (
            <HStack flex={1} width={"100%"} space={[0, 0, 3, 4]}>
              <HStack flex={[1, 1, 3]}>
                <VStack flex={1}>
                  <Box
                    height={"auto"}
                    borderRadius={5}
                    backgroundColor={"AVColor.white"}
                    shadow={1}
                    borderTopLeftRadius={10}
                    borderTopRightRadius={10}
                    marginBottom={"12px"}
                  >
                    <ProfileHeader
                      props={undefined}
                      isCreate={true}
                      setIsCreateDependents={undefined}
                      isCreateDependents={undefined}
                      isShowEdit={undefined}
                      Entity={undefined}
                      leagueGameEntity={undefined}
                      setLeagueGameEntity={undefined}
                      handleUpload={undefined}
                      EntityType={undefined}
                      type={createType}
                      setIsShowEdit={undefined}
                      profile={profile}
                      setProfile={setProfile}
                      googlemap={undefined}
                      isAdminView={undefined}
                      setIsAdminView={undefined}
                      weatherURL={undefined}
                      weather={undefined}
                      Owner={undefined}
                      setIsImagePopup={undefined}
                      setEntity={undefined}
                      editAccess={undefined}
                      setIsStaffReq={undefined}
                      setIsChildOrgReq={undefined}
                      openPreview={openPreview}
                      isDeleted={undefined}
                      HandleBlockUser={undefined}
                      HandleUnBlockUser={undefined}
                      HandleRestoreAccount={undefined}
                      HandleUnFollowUser={undefined}
                      setIsOpenConvo={setIsOpenConvo}
                      setIsConvoData={setIsConvoData}
                      setIsEditEntireSeries={setIsEditEntireSeries}
                      isEditEntireSeries={isEditEntireSeries}
                      seriesEvent={""}
                      setIshuddleData={undefined}
                      isRequestAgain={false}
                      setIsRequestAgain={undefined}
                      isShowPayPopup={undefined}
                      setIsShowPayPopup={undefined}
                      setClickedUrl={undefined}
                      setShowConfirmLinkPopup={undefined}
                      //isShowAddGuestTeam={undefined}
                      //setIsShowAddGuestTeam={undefined}
                      //guestTeamName={undefined}
                      //setGuestTeamName={undefined}
                      //guestTeamLocation={undefined}
                      //setGuestTeamLocation={undefined}
                    />

                    <AVCreateTeam
                      isCreate={true}
                      setIsCreate={undefined}
                      type={createType}
                      profile={profile}
                      isShowEdit={false}
                      setIsShowEdit={undefined}
                      teamType={createType}
                      Entity={undefined}
                      setEntity={undefined}
                      EntityDataFinding={undefined}
                      setgooglemap={undefined}
                      setProfile={setProfile}
                      handleUpload={undefined}
                      setShowCreateNewPage={setShowCreateNewPage}
                      setCreateType={setCreateType}
                      passEntity={passEntity}
                      setPassEntity={setPassEntity}
                      isEditEntireSeries={isEditEntireSeries}
                      setIsEditEntireSeries={setIsEditEntireSeries}
                      seriesEvent={""}
                    />
                  </Box>
                </VStack>
              </HStack>
            </HStack>
          )}
        </VStack>

        {type !== "accountsettings" ? (
          <Right
            setShowCreateNewPage={setShowCreateNewPage}
            setType={setCreateType}
            passEntity={passEntity}
            setPassEntity={setPassEntity}
            leagueGameEntity={leagueGameEntity}
            setIsShowEdit={setIsShowEdit}
          />
        ) : (
          <Hidden only={["base", "sm", "md"]}>
            <Box width={"227px"}></Box>
          </Hidden>
        )}

        {showPreview && (
          <PreviewAlbums
            item={singleImage}
            items={allImages}
            setShowPreview={setShowPreview}
            setShowAllImage={setShowAllImage}
          />
        )}
      </HStack>
    </div>
  );
};

export default AVBody;
